import type { RouteLocationNormalized } from 'vue-router'

/**
 * Composable to handle fallback content generation
 * for routes that don't have a CMS managed page.
 *
 */
export default function () {
  /**
   * Generate a bare bones 'just enough to work' fallback story for a given route
   */
  const fallbackStoryForRoute = () => {
    const route = useRoute()
    const component = getComponentForFallback(route)
    if (!component) return null
    // return just enough of a 'story' to render a fallback page
    return {
      fallback: true,
      uuid: route.path,
      content: {
        _uid: 'fallback--' + slugify(route.path),
        component: component,
      },
      slug: route.path.split('/').pop(),
      full_slug: route.path,
    }
  }

  /**
   * Manually match a given route to a render Component
   * For fallback content generation
   */
  const getComponentForFallback = function (route: RouteLocationNormalized) {
    if (route.path.startsWith('/featured-topics')) return 'FeaturedTopicPage'
    if (route.path.startsWith('/audiences')) return 'AudiencePage'
    // ... others?

    // nope
    return null
  }

  return { fallbackStoryForRoute }
}
